import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { server_connection } from 'config';


class FileUpload extends Component {
    handleUpload = (ev) => {
        ev.preventDefault();

        const data = new FormData();
        data.append('avatar', this.uploadInput.files[0]);

        fetch(server_connection + '/asset/upload',
            {
                method: 'POST',
                body: data
            })
            .then((responseData) => {
            });
    }

    render() {
        return (
            <div >
                <form onSubmit={this.handleUpload}>
                    <div className="form-group">
                        <input className="form-control" ref={(ref) => { this.uploadInput = ref; }} type="file" />
                    </div>

                    <button className="btn btn-success" >Upload</button>

                </form>
            </div>
        )
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(null, null)(FileUpload)));


// WEBPACK FOOTER //
// src/main/components/upload/FileUpload.js